import React from "react";
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import {useParams,Link} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { format } from "date-fns";
import { medecinComp, medecinuom } from '../utils/datalist';
import { Modal, Button, Form } from "react-bootstrap";

const ItemEntryCom=()=>{

    const [assetData,setAssetData]=useState([]);
    const [itemData,setItemData]=useState([]);
    const [inputData,setInputData]=useState([]);
    const [assetHistory,setAssetHistory]=useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [itemGroup,setItemGroup]=useState();
    const [itemGroupTemp,setItemGroupTemp]=useState(itemGroup);
    const [itemSearch,setItemSearch]=useState();
    const [itemGroupSearch,setItemGroupSearch]=useState();

    const [itemGpSearch,setItemGpSearch]=useState();


    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showOS, setShowOS] = useState(false);
    const handleCloseOS = () => setShowOS(false);
    const handleShowOS = () => setShowOS(true);

    const getAssetData = async () => {
          const response=await axios.get(configData.SERVER_URL+`/itemData/${localStorage.getItem('branchID')}`);
          setAssetData(response.data); 
          setItemData(response.data);      
    };

    const getItemGroupData=async()=>{
        const groupData=await axios.get(configData.SERVER_URL+`/itemGroup`);
        
        setItemGroup(groupData.data.data);
        console.log(itemGroup);
        setItemGroupTemp(groupData.data.data);
    } 

    useEffect(() => {
        getAssetData();
        getItemGroupData();
    }, []);


    const handleInput=(e)=>{
        const {name,value}=e.target; 
        setInputData({...inputData,[name]:value});  
    }

    const handleInputData=(e)=>{
        const {name,value}=e.target; 

        const newData = {...inputData,[name]: value}; 
    
        newData.branchID = localStorage.getItem('branchID'); 
        setInputData(newData); 
    }


    const handleSubmitInsert =async(e) => {
        e.preventDefault(); 

        try {
            let res=await axios.post(configData.SERVER_URL+`/ItemInsert`,inputData);
            if(res.status===200){
                alert(res.data.message);
                getAssetData();
            } 
            } catch (error) {
            console.error('System error:', error);
        } 
        handleClose();
    };

    const handleSubmitEdit =async(e) => {
        e.preventDefault(); 

        try {
            let res=await axios.post(configData.SERVER_URL+`/itemEdit`,inputData);
            if(res.status===200){
                alert(res.data.message);
                getAssetData();
            } 
            } catch (error) {
            console.error('System error:', error);
        } 
        handleClose();
    };

    const handleSubmitDelete =async(id) => {
        if (window.confirm("want to delete this item ?")) {
        try {
            let res=await axios.get(configData.SERVER_URL+`/itemDelete/${id}`);
            if(res.status===200){
                alert(res.data.message);
                getAssetData();
            } 
            } catch (error) {
            console.error('System error:', error);
        } 
        handleClose();
        }
    };

    const handleSubmit_OS =async(e) => {
        e.preventDefault(); 

        try {
            let res=await axios.post(configData.SERVER_URL+`/itemEditOS`,inputData);
            if(res.status===200){
                alert(res.data.message);
                getAssetData();
            } 
            } catch (error) {
            console.error('System error:', error);
        } 
        handleCloseOS();
    };

    const addTarget=()=>{
        setIsEditing(false);
        handleShow();
    }

    const editTarget=(data)=>{
        setIsEditing(true);
        setInputData(data);
        handleShow();
    }

    const editTargetOS=(data)=>{
        setInputData(data);
        handleShowOS();
    }

    const filterItem = (e) => {
    const value = e.target.value.toLowerCase();   
    setItemSearch(value);

    const updatedList = assetData.filter(iGroup =>
        iGroup.itemCode?.toLowerCase().includes(value) ||
        iGroup.itemName?.toLowerCase().includes(value)
    );
    setItemData(updatedList);
    };

    const filterItemByGroup = (e) => {
    const value = e.target.value.toLowerCase();   
    setItemGpSearch(value);

    const updatedList = assetData.filter(iGroup =>
        iGroup.groupCode?.toLowerCase().includes(value) ||
        iGroup.groupName?.toLowerCase().includes(value)
    );
    setItemData(updatedList);
    };

    const filterGroup = (e) => {
    const value = e.target.value.toLowerCase();   
    setItemGroupSearch(value);

    const updatedList = itemGroup.filter(iGroup =>
        iGroup.groupName?.toLowerCase().includes(value)
    );

    setItemGroupTemp(updatedList);
    };

    const printDiv_Item = () => {

    const printContent = document.getElementById('printItem').innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
    };

    return(
        <>
       
        <div className="well">
                <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>{isEditing ? 'Edit' : 'Insert'} Item Entry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form onSubmit={isEditing ? handleSubmitEdit : handleSubmitInsert}>
                <Form.Group className="mb-3">
                    <Form.Label>Item Group</Form.Label>
                    <Form.Control type="text" list="items" id="groupName" name="groupName" value={inputData.groupName}  onChange={(e)=>{handleInputData(e)}} placeholder="Search by Generic name"/>
                    <datalist id="items">
                        {itemGroup && itemGroup.length>0 && itemGroup.map((item) => (
                        <option key={item.groupName} value={item.groupName} />
                        ))}
                    </datalist>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Item Code</Form.Label>
                    <Form.Control type='text' id='itemCode' name='itemCode' onChange={(e)=>{handleInputData(e)}} value={inputData.itemCode} required disabled={isEditing} />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Item Name</Form.Label>
                    <Form.Control type='text' id='itemName' name='itemName' onChange={(e)=>{handleInputData(e)}} value={inputData.itemName} required />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Manufacturer</Form.Label>
                    <Form.Select  id="menufacturer" name="menufacturer" onChange={(e)=>{handleInputData(e)}}  value={inputData.menufacturer} required >
                        <option value=''>---</option>
                        {medecinComp.map(comp => (
                        <option key={comp.name} value={comp.name}>{comp.name}</option>
                        ))}   
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Unit</Form.Label>
                    <Form.Select  id="uom" name="uom" onChange={(e)=>{handleInputData(e)}}  value={inputData.uom} required >
                        <option value=''>---</option>
                        {medecinuom.map(munit => (
                        <option key={munit.name} value={munit.name}>{munit.name}</option>
                        ))}   
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Unit Price</Form.Label>
                    <Form.Control type='number' id='itemPrice' name='itemPrice' onChange={(e)=>{handleInputData(e)}} value={inputData.itemPrice} required/>
                </Form.Group>               
                
                <Form.Group className="mb-3">
                    <Button variant="success" type="submit" id="btnTargetEntry">Submit</Button>
                </Form.Group>
            </Form>
        </Modal.Body>
        <Modal.Footer closeButton></Modal.Footer>
                </Modal>

                <Modal show={showOS} onHide={handleCloseOS}>
            <Modal.Header closeButton>
            <Modal.Title>Item Entry</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit_OS}>
                    <Form.Group className="mb-3">
                    <Form.Label>Item Code</Form.Label>
                    <Form.Control type='text' onChange={(e)=>{handleInputData(e)}} value={inputData.itemCode} disabled='true' />
                    </Form.Group>

                    <Form.Group className="mb-3">
                    <Form.Label>Item Name</Form.Label>
                    <Form.Control type='text' onChange={(e)=>{handleInputData(e)}} value={inputData.itemName} disabled='true' />
                    </Form.Group>

                    <Form.Group className="mb-3">
                    <Form.Label>Financial Year</Form.Label>
                    <Form.Control type='number' id='fYear' name='fYear' onChange={(e)=>{handleInputData(e)}} value={inputData.fYear} required/>
                    </Form.Group>

                    <Form.Group className="mb-3">
                    <Form.Label>Opening Stock</Form.Label>
                    <Form.Control type='number' id='openingStock' name='openingStock' onChange={(e)=>{handleInputData(e)}} value={inputData.openingStock} required/>
                    </Form.Group>

                    <Form.Group className="mb-3">
                    <Button variant="success" type="submit">Submit</Button>
                    </Form.Group>

                </Form>
            </Modal.Body>
            <Modal.Footer closeButton></Modal.Footer>
                </Modal>
                
                <div className="card well bg-info "> 
                <div className="card-header"> 
                Item Information
                <button type="button" class="btn btn-info"  onClick={() => {addTarget()}} style={{marginLeft:'10px'}}><span><Icon.PlusCircle size={24}/></span></button>
                <button type="button" class="btn btn-info" style={{borderRadius:'30px'}}>
                    <span onClick={printDiv_Item}><Icon.Printer/></span>              
                </button>
                </div>
                <div className="card-body p=0" id="printItem" style={{maxHeight: "600px",backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px", overflowY: "auto"}}>
                <div className="table-responsive">
                <table className="table table-condensed  table-success table-hover table-bordered mb=0" style={{fontSize:'12px'}}>
                    <thead className="table-info">
                        <tr>
                        <th>SL No.</th>
                        <th width='200px'>Filter by Generic Name/Brand Name<hr></hr>
                           
                            <input type='text' className="form-control"   id='itemSearch' name='itemSearch' placeholder="Search by Code/Name" onChange={(e)=>filterItem(e)} value={itemSearch} />
                        </th>
                        <th>Manufacturer</th>
                        <th>UOM</th>
                        <th>Unit Price</th>   
                        <th>Opening Stock</th>
                        <th>Receive Qty</th>
                        <th>Issue Qty</th>
                        <th>Current Stock</th>                                        
                        <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                        itemData && itemData.length>0 && itemData.map((data,index)=>
                        <tr align="right" key={data.id}>
                            <td align="left">{index+1}</td> 
                            <td align="left">{data.itemCode}<br></br>{data.itemName}<br></br>{data.groupName}</td>
                            <td align="left">{data.menufacturer}</td>
                            <td align="left">{data.uom}</td>                            
                            <td align="left">{data.itemPrice}</td>
                            <td align="left">{data.openingStock}</td>
                            <td align="left">{data.mrr_qty}</td>
                            <td align="left">{data.issueQty}</td>
                            <td align="left">{data.currentStock}</td>
                            <td>                           
                            <button type="button" class="btn btn-info" onClick={()=>editTarget(data)}><span><Icon.Pencil/></span></button>
                            <button type="button" class="btn btn-info" onClick={()=>editTargetOS(data)}><span><Icon.Basket/></span></button>
                            <button type="button" class="btn btn-danger" onClick={()=>handleSubmitDelete(data.id)}><span><Icon.FileMinus /></span></button>
                            </td>
                        </tr>
                        )}
                        
                    </tbody>
                </table>
                </div>
                </div>
                </div>

        </div>
        
        </>
    )

}

export default ItemEntryCom;